module.exports = __webpack_public_path__ + "img/person.cab8f1f0.png";